import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Refund() {
  return (
    <LegalPage title="Refund Policy" eyebrow="REFUNDS" lastUpdated="January 2026">
      <p>
        This Refund Policy applies to all goods and services sold by{" "}
        <strong>Tapped In Clarity</strong>, a sole trader business in the
        United Kingdom. By purchasing from us you agree to the terms below.
      </p>

      <h2>1. Digital Goods — No Refunds</h2>
      <p>
        The Albetheine Oracle app subscription (£9.99 every 3 months), the
        online Guidebook (£27), the Guidebook + 3 Months App bundle (£34.99),
        and any other digital downloads are <strong>non-refundable</strong> once
        access has been granted or the content delivered.
      </p>
      <p>
        By completing your purchase of any digital product you expressly agree
        to immediate digital delivery and acknowledge that this waives your
        statutory 14-day right of cancellation for digital content under the
        Consumer Contracts Regulations 2013.
      </p>

      <h2>2. Psychic Medium Readings (£150 / 60 minutes)</h2>
      <ul>
        <li>
          Once a reading has been held it is non-refundable.
        </li>
        <li>
          If you need to reschedule, please see our{" "}
          <a href="/cancellation">Cancellation Policy</a>.
        </li>
        <li>
          If we have to cancel a reading on our side and cannot offer a suitable
          alternative time within 30 days, you will receive a full refund.
        </li>
      </ul>

      <h2>3. Physical Oracle Decks (Coming Soon — Print on Demand)</h2>
      <p>
        Our Albetheine&apos;s Beacon Oracle Deck and Albetheine&apos;s Shadow Oracle Deck are
        produced on a <strong>print-on-demand</strong> basis. This means each
        deck is printed specifically for your order. As a result:
      </p>
      <ul>
        <li>
          <strong>We do not offer refunds on opened decks</strong> unless the
          item is faulty or damaged on arrival.
        </li>
        <li>
          <strong>Unopened decks</strong> may be returned within{" "}
          <strong>14 days</strong> of delivery for a <strong>partial refund</strong>.
        </li>
        <li>
          The customer remains liable for the original printing and postage
          costs, which will be deducted from any partial refund. Return shipping
          is also the customer's responsibility.
        </li>
        <li>
          Returns must be sent back in their original, sealed packaging, in
          re-sellable condition.
        </li>
      </ul>

      <h2>4. Faulty or Damaged Decks</h2>
      <p>
        If your physical deck arrives faulty, misprinted or damaged, please
        email{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>{" "}
        within <strong>14 days of receipt</strong> with:
      </p>
      <ul>
        <li>Your order number.</li>
        <li>Clear photographs of the issue.</li>
        <li>A brief description of the fault.</li>
      </ul>
      <p>
        Where the fault is verified, we will at our discretion offer either a
        free replacement deck or a full refund (including original postage).
      </p>

      <h2>5. How to Request a Return</h2>
      <ol>
        <li>
          Email <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>{" "}
          with your order number and reason within 14 days of delivery.
        </li>
        <li>
          We will respond within 3 working days with the return address and
          instructions.
        </li>
        <li>
          Once we receive the unopened deck and have inspected it, any partial
          refund will be processed to your original payment method within 14
          days.
        </li>
      </ol>

      <h2>6. Merchandise (When Available)</h2>
      <p>
        Future Albetheine merchandise will follow the same print-on-demand
        terms as the oracle decks, unless otherwise stated on the product page.
      </p>

      <h2>7. Your Statutory Rights</h2>
      <p>
        Nothing in this policy affects your statutory rights under UK consumer
        law, including the Consumer Rights Act 2015. If you believe a product
        is faulty, not as described, or not fit for purpose, please contact us.
      </p>

      <h2>8. Contact</h2>
      <p>
        All refund and return requests:{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>.
      </p>
    </LegalPage>
  );
}
